export default __webpack_public_path__ + "static/media/Valentine.2bc13dd4.png";